import React from 'react'
import Icon from '@mui/material/Icon'
import { Button, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

interface IButtonComponentProps {
  color?: 'primary' | 'secondary' | 'info'
  className?: any
  disabled?: boolean
  disableElevation?: boolean
  variant?: 'contained' | 'text' | 'outlined'
  size?: 'small' | 'medium' | 'large'
  startIcon?: JSX.Element | string
  text?: any
  type?: 'button' | 'submit' | 'reset'
  onClick?: () => void
  link?: string
  target?: string
  fullWidth?: boolean
}

export interface IButtonProps {
  color?: 'primary' | 'secondary' |'info'
  disabled?: boolean
  disableElevation?: boolean
  variant?: 'contained' | 'text' | 'outlined'
  size?: 'small' | 'medium' | 'large'
  type?: 'button' | 'submit' | 'reset'
}

const defaultSettings: IButtonProps = {
  disabled: false,
  disableElevation: true,
  variant: 'contained',
  size: 'medium',
  type: 'button',
}

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    '&:hover': {
      border: '0px',
    },
  },
  base: {
    '&.MuiButton-root': {
      lineHeight: 1.6,
      '& span': {
        display: 'flex',
      },
    },
  },
}))

const ButtonComponent: React.FC<IButtonComponentProps> = (props) => {
  const classes = useStyles()
  const startIcon = props.startIcon
  const color: 'primary' | 'secondary' | 'info' | undefined = props.color ? props.color : undefined
  const disabled = props.disabled ? props.disabled : defaultSettings.disabled
  const disableElevation = props.disableElevation ? props.disableElevation : defaultSettings.disableElevation
  const variant: 'contained' | 'text' | 'outlined' | undefined = props.variant ? props.variant : defaultSettings.variant
  const size: 'small' | 'medium' | 'large' | undefined = props.size ? props.size : defaultSettings.size
  const type: 'button' | 'submit' | 'reset' | undefined = props.type ? props.type : defaultSettings.type
  const link: string = props.link ? props.link : ''
  const target: string = props.target ? props.target : '_blank'
  const fullWidth: boolean = props.fullWidth || false

  if (startIcon) {
    return ( // button with startIcon
      <Button
        href={link}
        target={target}
        color={color}
        className={`${props.className} ${variant === 'text' && classes.text}`}
        variant={variant}
        type={type}
        size={size}
        fullWidth={fullWidth}
        disabled={disabled}
        disableElevation={disableElevation}
        aria-label={props.text}
        startIcon={(typeof props.startIcon === 'string') ? <Icon style={{ textTransform: 'none' }}>{props.startIcon}</Icon> : props.startIcon}
        onClick={() => props.onClick && props.onClick()}
      >
        {props.text}
      </Button>
    )
  } else {
    return ( // button without startIcon
      <Button
        href={link}
        target={target}
        color={color}
        className={`${props.className} ${classes.base} ${variant === 'text' && classes.text}`}
        variant={variant}
        size={size}
        disabled={disabled}
        fullWidth={fullWidth}
        disableElevation={disableElevation}
        aria-label={props.text}
        onClick={() => props.onClick && props.onClick()}
        type={type}
      >
        {props.text}
      </Button>
    )
  }
}
export default ButtonComponent
